import { byId, button, clear, el } from "./dom";

/** A bottom sheet on phones, a side panel on wide screens. Only one is open at a time. */
export interface Sheet {
  readonly body: HTMLElement;
  setTitle(title: string): void;
  close(): void;
  isOpen(): boolean;
}

let current: { sheet: Sheet; onClose?: () => void } | null = null;

export function openSheet(title: string, onClose?: () => void): Sheet {
  closeSheet();

  const root = byId("panel-root");
  const titleEl = el("h2", { class: "sheet__title", text: title });
  const body = el("div", { class: "sheet__body" });
  const closeBtn = button("✕", "icon-btn", () => closeSheet());
  closeBtn.setAttribute("aria-label", "Bezárás");

  const node = el("section", { class: "sheet", attrs: { role: "dialog", "aria-label": title } }, [
    el("div", { class: "sheet__grip" }),
    el("header", { class: "sheet__head" }, [titleEl, closeBtn]),
    body,
  ]);
  root.append(node);
  document.body.classList.add("has-sheet");

  const sheet: Sheet = {
    body,
    setTitle(t) {
      titleEl.textContent = t;
      node.setAttribute("aria-label", t);
    },
    close: () => closeSheet(),
    isOpen: () => current?.sheet === sheet,
  };
  current = { sheet, onClose };
  return sheet;
}

export function closeSheet(): void {
  if (!current) return;
  const { onClose } = current;
  current = null;
  clear(byId("panel-root"));
  document.body.classList.remove("has-sheet");
  onClose?.();
}

document.addEventListener("keydown", (ev) => {
  if (ev.key === "Escape") closeSheet();
});

/** Replaces the sheet body with a centered status line. */
export function setStatus(sheet: Sheet, text: string, kind: "loading" | "error" = "loading"): void {
  clear(sheet.body);
  sheet.body.append(el("p", { class: `sheet__status sheet__status--${kind}`, text }));
}

let toastTimer: number | undefined;

export function toast(message: string, kind: "ok" | "error" = "ok"): void {
  const root = byId("toast-root");
  clear(root);
  root.append(el("div", { class: `toast toast--${kind}`, text: message }));
  if (toastTimer !== undefined) window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => clear(root), 4000);
}
